import { useRecipesHook } from "../../../Hooks/communicators/useRecipesHook";

export default function RecipeSelector() {
    const {
        selectedRecipePage,
        changeSelectedRecipePage,
    } = useRecipesHook();

    return (
        <div className='my-8 flex justify-center items-center flex-col'>
            <p className='text-2xl font-normal mb-4'>Manage Recipes</p>
            <p className='text-lg font-light mb-4'>Select an action to perform on recipes</p>
            <div className='flex justify-between items-center my-4'>
                <div className='flex justify-end items-center'>
                    <button
                        onClick={() => changeSelectedRecipePage(1)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>List Recipes</button>
                    <button
                        onClick={() => changeSelectedRecipePage(2)}
                        className='bg-green-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Add New Recipe</button>
                    <button
                        onClick={() => changeSelectedRecipePage(3)}
                        className='bg-yellow-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Update Recipe</button>
                    <button
                        onClick={() => changeSelectedRecipePage(4)}
                        className='bg-red-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Delete Recipe</button>
                </div>
            </div>
        </div>
    )
}
